import { render, staticRenderFns } from "./contentCourseEdit.vue?vue&type=template&id=56610504&"
import script from "./contentCourseEdit.vue?vue&type=script&lang=js&"
export * from "./contentCourseEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports